import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FieldData } from "src/app/share/interface/common.interface";

@Component({
  selector: "app-approve-application",
  templateUrl: "./approve-application.component.html",
  styleUrls: ["./approve-application.component.scss"]
})
export class ApproveApplicationComponent implements OnInit {
  fieldList: FieldData[] = [];

  constructor(
    private dialogRef: MatDialogRef<ApproveApplicationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ApproveData
  ) {}

  ngOnInit(): void {
    this.fieldList = [
      {
        codeDesc: "common.insuranceRoadtaxRenewalApplicationAmt",
        codeValue: `RM ${this.data.roadtaxRenewalPayment.toFixed(2)}`
      },
      {
        codeDesc: "kopetro.reviewApplication.monthlyInstalmentAmt",
        codeValue: `RM ${this.data.monthlyInstallment.toFixed(2)}`
      },
      {
        codeDesc: "kopetro.reviewApplication.installmentMonth",
        codeValue: `${this.data.tenure} Bulan`
      }
    ];
  }

  onSubmit(): void {
    this.dialogRef.close(true);
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
}

interface ApproveData {
  roadtaxRenewalPayment: number;
  monthlyInstallment: number;
  tenure: number;
}
